export const FETCH_EXERCISES_START = 'FETCH_EXERCISES_START';
export const FETCH_EXERCISES_FULFILLED = 'FETCH_EXERCISES_FULFILLED';
export const FETCH_EXERCISES_REJECTED = 'FETCH_EXERCISES_REJECTED';

export const FETCH_GROUPS_START = 'FETCH_GROUPS_START';
export const FETCH_GROUPS_FULFILLED = 'FETCH_GROUPS_FULFILLED';
export const FETCH_GROUPS_REJECTED = 'FETCH_GROUPS_REJECTED';

export const FETCH_LEADERBOARD_START = 'FETCH_LEADERBOARD_START';
export const FETCH_LEADERBOARD_FULFILLED = 'FETCH_LEADERBOARD_FULFILLED';
export const FETCH_LEADERBOARD_REJECTED = 'FETCH_LEADERBOARD_REJECTED';

export const EDIT_LEADERBOARD_START = 'EDIT_LEADERBOARD_START';
export const EDIT_LEADERBOARD_FULFILLED = 'EDIT_LEADERBOARD_FULFILLED';
export const EDIT_LEADERBOARD_REJECTED = 'EDIT_LEADERBOARD_REJECTED';

export const STASH_PENDING_RELOAD = 'STASH_PENDING_RELOAD';
export const APPLY_PENDING_RELOAD = 'APPLY_PENDING_RELOAD';

export const FETCH_LEADERBOARD_CSV_START = 'FETCH_LEADERBOARD_CSV_START';
export const FETCH_LEADERBOARD_CSV_FULFILLED = 'FETCH_LEADERBOARD_CSV_FULFILLED';
export const FETCH_LEADERBOARD_CSV_REJECTED = 'FETCH_LEADERBOARD_CSV_REJECTED';

export const FETCH_NEXT_PAGE_START = 'FETCH_NEXT_PAGE_START';
export const FETCH_NEXT_PAGE_FULFILLED = 'FETCH_NEXT_PAGE_FULFILLED';
export const FETCH_NEXT_PAGE_REJECTED = 'FETCH_NEXT_PAGE_REJECTED';

export const CLOSE_BOARD = 'CLOSE_BOARD';

export const UPDATE_SETTING = 'UPDATE_SETTING';

export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';

export const FETCH_TEMPLATES_START = 'FETCH_TEMPLATES_START';
export const FETCH_TEMPLATES_FULFILLED = 'FETCH_TEMPLATES_FULFILLED';
export const FETCH_TEMPLATES_REJECTED = 'FETCH_TEMPLATES_REJECTED';

export const SAVE_TEMPLATE_START = 'SAVE_TEMPLATE_START';
export const SAVE_TEMPLATE_FULFILLED = 'SAVE_TEMPLATE_FULFILLED';
export const SAVE_TEMPLATE_REJECTED = 'SAVE_TEMPLATE_REJECTED';

export const UPDATE_TEMPLATE_START = 'UPDATE_TEMPLATE_START';
export const UPDATE_TEMPLATE_FULFILLED = 'UPDATE_TEMPLATE_FULFILLED';
export const UPDATE_TEMPLATE_REJECTED = 'UPDATE_TEMPLATE_REJECTED';

export const DELETE_TEMPLATE_START = 'DELETE_TEMPLATE_START';
export const DELETE_TEMPLATE_FULFILLED = 'DELETE_TEMPLATE_FULFILLED';
export const DELETE_TEMPLATE_REJECTED = 'DELETE_TEMPLATE_REJECTED';

export const MARK_BOARD_AS_TEMPLATE = 'MARK_BOARD_AS_TEMPLATE';

export const SET_LEADERBOARD_VIEW = 'SET_LEADERBOARD_VIEW';

export const CLEAR_ALL_BOARDS = 'CLEAR_ALL_BOARDS';

export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS';
